import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { SpinElDirectiveModule } from '@signature-it/ngx-generic/directives';
import { SuccessModalModuleGeneric } from '@signature-it/ngx-catalogue/components/success-modal';
import { AddToCartBtnComponent } from './add-to-cart-btn.component';


@NgModule({
  declarations: [
      AddToCartBtnComponent,
  ],
  imports: [
      CommonModule,
      TranslateModule,
      SuccessModalModuleGeneric,
      FormsModule,
      RouterModule,
      SpinElDirectiveModule
  ],
  exports: [
      AddToCartBtnComponent,
  ]
})
export class AddToCartBtnModule {}
